"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _reactRedux = require("react-redux");
var _loading = require("./loading.js");
var _loading2 = require("../helpers/loading.js");
var _performanceOverview = require("../selectors/performanceOverview.js");
var performanceLoadingHookGenerator = function performanceLoadingHookGenerator(action) {
  return function (_ref) {
    var userId = _ref.userId,
      questionBankId = _ref.questionBankId,
      options = _ref.options;
    var dispatch = (0, _reactRedux.useDispatch)();
    var key = questionBankId ? action.getKey(questionBankId, userId) : action.getKey(userId);
    var loaded = (0, _loading.useIsLoaded)(key);
    var loading = (0, _loading.useIsLoading)(key);
    var stale = (0, _reactRedux.useSelector)(function (state) {
      return new Date().getTime() - state.loadedAt.get(key, 0) > 1000 * 60;
    });
    var dispatchAction = function dispatchAction() {
      if (questionBankId) return dispatch(action(questionBankId, userId));
      return dispatch(action(userId, options === null || options === void 0 ? void 0 : options.startDate, options === null || options === void 0 ? void 0 : options.endDate));
    };
    (0, _react.useEffect)(function () {
      if (loading) return;
      if (loaded && !stale) return;
      dispatchAction();
    }, [loaded, loading, stale]);
    return !loaded || loading;
  };
};
var PerformanceHooks = /*#__PURE__*/_createClass(function PerformanceHooks(_ref2) {
  var _this = this;
  var Performance = _ref2.Performance;
  _classCallCheck(this, PerformanceHooks);
  this.usePerformanceOverviewForCurrentUser = function () {
    return (0, _reactRedux.useSelector)(function (state) {
      return (0, _performanceOverview.selectPerformanceOverview)(state);
    });
  };
  this.usePerformanceOverviewWithFilters = function () {
    var allowFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return (0, _reactRedux.useSelector)(function (state) {
      return (0, _performanceOverview.selectPerformanceOverview)(state, null, null, allowFilter);
    });
  };
  this.useAssignmentsEssentials = function (questionBanks) {
    var isIframe = (0, _reactRedux.useSelector)(function (state) {
      return state.session;
    }).get('isIframe');
    var loadedQuestionBankId = isIframe ? (0, _reactRedux.useSelector)(function (state) {
      return state.session;
    }).get('selected_question_bank_id') : 0;
    var loadedQuestionBanks = loadedQuestionBankId ? questionBanks.filter(function (qb) {
      return qb.value === loadedQuestionBankId;
    }) : null;
    return {
      loadedQuestionBankId: loadedQuestionBankId,
      loadedQuestionBanks: loadedQuestionBanks
    };
  };
  this.Performance = Performance;
  this.useLoadQuizzesAndResponsesIfNeeded = function (userIdArg, options) {
    var userId = userIdArg || (0, _reactRedux.useSelector)(function (state) {
      return state.session.get('current_user_id');
    });
    var dispatch = (0, _reactRedux.useDispatch)();
    var quizzesKey = _this.Performance.performanceQuizzesFetch.getKey(userId);
    var responsesKey = _this.Performance.performanceResponsesFetch.getKey(userId);
    var loadedQuizzes = (0, _loading.useIsLoaded)(quizzesKey);
    var loadedResponses = (0, _loading.useIsLoaded)(responsesKey);
    var loadingQuizzes = (0, _loading.useIsLoading)(quizzesKey);
    var loadingResponses = (0, _loading.useIsLoading)(responsesKey);

    // Load Quizzes/Responses once per page load/refresh.
    // User must refresh whole page to fetch new/updated data.
    // const loadedQuizzesThisSession = loadingPromiseDefined(quizzesKey);
    // const loadedResponsesThisSession = loadingPromiseDefined(responsesKey);

    // Load Quizzes/Responses every time hook is called (limited to once every 60 seconds).
    // Navigating in App 2.0 fetches new/updated data.
    var staleQuizzes = (0, _reactRedux.useSelector)(function (state) {
      return new Date().getTime() - state.loadedAt.get(quizzesKey, 0) > 1000 * 60;
    });
    var staleResponses = (0, _reactRedux.useSelector)(function (state) {
      return new Date().getTime() - state.loadedAt.get(responsesKey, 0) > 1000 * 60;
    });
    (0, _react.useEffect)(function () {
      if (loadingQuizzes) return;
      if (loadedQuizzes && !staleQuizzes) return;
      dispatch(_this.Performance.performanceQuizzesFetch(userId, options === null || options === void 0 ? void 0 : options.startDate, options === null || options === void 0 ? void 0 : options.endDate));
    }, [loadedQuizzes, staleQuizzes]);
    (0, _react.useEffect)(function () {
      if (loadingResponses) return;
      if (loadedResponses && !staleResponses) return;
      dispatch(_this.Performance.performanceResponsesFetch(userId, options === null || options === void 0 ? void 0 : options.startDate, options === null || options === void 0 ? void 0 : options.endDate));
    }, [loadedResponses, staleResponses]);
    return loadingQuizzes || !loadedQuizzes || loadingResponses || !loadedResponses;
  };
  this.useLoadQuizzesIfNeeded = performanceLoadingHookGenerator(this.Performance.performanceQuizzesFetch);
  this.useLoadQuestionsIfNeeded = performanceLoadingHookGenerator(this.Performance.performanceQuestionsFetch);
  this.useLoadResponsesIfNeeded = performanceLoadingHookGenerator(this.Performance.performanceResponsesFetch);
  this.useLoadQuizzesResponsesAndQuestionsIfNeeded = function (userIdArg, questionBankId, options) {
    var userId = userIdArg || (0, _reactRedux.useSelector)(function (state) {
      return state.session.get('current_user_id');
    });
    var dispatch = (0, _reactRedux.useDispatch)();
    var quizzesKey = _this.Performance.performanceQuizzesFetch.getKey(userId);
    var responsesKey = _this.Performance.performanceResponsesFetch.getKey(userId);
    var questionsKey = _this.Performance.performanceQuestionsFetch.getKey(questionBankId, userId);
    var loadedQuizzes = (0, _loading.useIsLoaded)(quizzesKey);
    var loadedResponses = (0, _loading.useIsLoaded)(responsesKey);
    var loadedQuestions = (0, _loading.useIsLoaded)(questionsKey);
    var loadingQuizzes = (0, _loading.useIsLoading)(quizzesKey);
    var loadingResponses = (0, _loading.useIsLoading)(responsesKey);
    var loadingQuestions = (0, _loading.useIsLoading)(questionsKey);

    // Load Quizzes/Responses once per page load/refresh.
    // User must refresh whole page to fetch new/updated data.
    // const loadedQuizzesThisSession = loadingPromiseDefined(quizzesKey);
    // const loadedResponsesThisSession = loadingPromiseDefined(responsesKey);

    // Load Quizzes/Responses every time hook is called (limited to once every 60 seconds).
    // Navigating in App 2.0 fetches new/updated data.
    var staleQuizzes = (0, _reactRedux.useSelector)(function (state) {
      return new Date().getTime() - state.loadedAt.get(quizzesKey, 0) > 1000 * 60;
    });
    var staleResponses = (0, _reactRedux.useSelector)(function (state) {
      return new Date().getTime() - state.loadedAt.get(responsesKey, 0) > 1000 * 60;
    });
    var staleQuestions = (0, _reactRedux.useSelector)(function (state) {
      return new Date().getTime() - state.loadedAt.get(questionsKey, 0) > 1000 * 60;
    });
    (0, _react.useEffect)(function () {
      if (loadingQuizzes) return;
      if (loadedQuizzes && !staleQuizzes) return;
      dispatch(_this.Performance.performanceQuizzesFetch(userId, options === null || options === void 0 ? void 0 : options.startDate, options === null || options === void 0 ? void 0 : options.endDate));
    }, [loadedQuizzes, staleQuizzes]);
    (0, _react.useEffect)(function () {
      if (loadingResponses) return;
      if (loadedResponses && !staleResponses) return;
      dispatch(_this.Performance.performanceResponsesFetch(userId, options === null || options === void 0 ? void 0 : options.startDate, options === null || options === void 0 ? void 0 : options.endDate));
    }, [loadedResponses, staleResponses]);
    (0, _react.useEffect)(function () {
      if (loadingQuestions) return;
      if (loadedQuestions && !staleQuestions) return;
      dispatch(_this.Performance.performanceQuestionsFetch(questionBankId, userId));
    }, [loadedQuestions, staleQuestions]);
    return loadingQuizzes || !loadedQuizzes || loadingResponses || !loadedResponses || loadingQuestions || !loadedQuestions;
  };
  this.useLoadOrganizationPerformancePeersIfNeeded = function (questionBankIdArg) {
    var dispatch = (0, _reactRedux.useDispatch)();
    var userId = (0, _reactRedux.useSelector)(function (state) {
      return state.session.get('current_user_id');
    });
    var selectedQuestionBankId = (0, _reactRedux.useSelector)(function (state) {
      return state.session.get('selected_question_bank_id');
    });
    var selectingQuestionBank = (0, _loading.useIsLoading)(/^question-bank-select\/\d+$/);
    var questionBankId = questionBankIdArg || selectedQuestionBankId;
    var peersKey = _this.Performance.performanceSchoolPeersFetch.getKey(questionBankId, userId);
    var loadedPeers = (0, _loading.useIsLoaded)(peersKey);
    var loadingPeers = (0, _loading.useIsLoading)(peersKey);

    // Peer data is stale if it was fetched over 24 hours ago
    var stalePeers = (0, _reactRedux.useSelector)(function (state) {
      return new Date().getTime() - state.loadedAt.get(peersKey, 0) > 1000 * 60 * 60 * 24;
    });
    var _ref3 = (0, _react.useState)(false),
      _ref4 = _slicedToArray(_ref3, 2),
      loadPeerRank = _ref4[0],
      setLoadPeerRank = _ref4[1];
    (0, _react.useEffect)(function () {
      if (loadingPeers) return;
      if (loadedPeers && !stalePeers) return;
      dispatch(_this.Performance.performanceSchoolPeersFetch(questionBankId, userId));
    }, [loadedPeers, stalePeers]);
    (0, _react.useEffect)(function () {
      if (loadPeerRank && loadedPeers) dispatch(_this.Performance.performanceSchoolPeersFetch(questionBankId, userId));
      setLoadPeerRank(selectingQuestionBank);
    }, [selectingQuestionBank]);
    return loadingPeers || !loadedPeers;
  };
  this.useLoadPerformanceAllScoresIfNeeded = function (questionBankIdArg) {
    var dispatch = (0, _reactRedux.useDispatch)();
    var userId = (0, _reactRedux.useSelector)(function (state) {
      return state.session.get('current_user_id');
    });
    var selectedQuestionBankId = (0, _reactRedux.useSelector)(function (state) {
      return state.session.get('selected_question_bank_id');
    });
    var questionBankId = questionBankIdArg || selectedQuestionBankId;
    var selectingQuestionBank = (0, _loading.useIsLoading)(/^question-bank-select\/\d+$/);
    var key = _this.Performance.performanceAllStudentsFetch.getKey(questionBankId, userId);
    var loadedScores = (0, _loading.useIsLoaded)(key);
    var loadingScores = (0, _loading.useIsLoading)(key);

    // Score data is stale if it was fetched over 24 hours ago
    var staleScores = (0, _reactRedux.useSelector)(function (state) {
      return new Date().getTime() - state.loadedAt.get(key, 0) > 1000 * 60 * 60 * 24;
    });
    var _ref5 = (0, _react.useState)(false),
      _ref6 = _slicedToArray(_ref5, 2),
      loadScores = _ref6[0],
      setLoadScores = _ref6[1];
    (0, _react.useEffect)(function () {
      if (loadingScores) return;
      if (loadedScores && !staleScores) return;
      dispatch(_this.Performance.performanceAllStudentsFetch(questionBankId, userId));
    }, [loadedScores, staleScores]);
    (0, _react.useEffect)(function () {
      if (loadScores && loadedScores) dispatch(_this.Performance.performanceAllStudentsFetch(questionBankId, userId));
      setLoadScores(selectingQuestionBank);
    }, [selectingQuestionBank]);
    return loadingScores || !loadedScores;
  };
  this.useLoadPerformanceQuestionsAndPeersIfNeeded = function (questionBankIdArg, userIdArg, options) {
    var dispatch = (0, _reactRedux.useDispatch)();
    var userId = userIdArg || (0, _reactRedux.useSelector)(function (state) {
      return state.session.get('current_user_id');
    });
    var questionBankId = (0, _reactRedux.useSelector)(function (state) {
      return questionBankIdArg || state.session.get('selected_question_bank_id');
    });

    // Must also load data for Quizzes and Responses and Subjects
    var loadingQuizzesOrResponses = _this.useLoadQuizzesAndResponsesIfNeeded(userId, options);
    var subjectsLoading = (0, _loading.useIsLoading)(/^question-bank-subjects-fetch\/\d+$/);
    var questionsKey = _this.Performance.performanceQuestionsFetch.getKey(questionBankId, userId);
    var peersKey = _this.Performance.performancePeersFetch.getKey(questionBankId, userId);
    var loadedQuestions = (0, _loading.useIsLoaded)(questionsKey);
    var loadedPeers = (0, _loading.useIsLoaded)(peersKey);
    var loadingQuestions = (0, _loading.useIsLoading)(questionsKey);
    var loadingPeers = (0, _loading.useIsLoading)(peersKey);
    var loadedQuestionsThisSession = (0, _loading2.loadingPromiseDefined)(questionsKey);
    // Peer data is stale if it was fetched over 24 hours ago
    var stalePeers = (0, _reactRedux.useSelector)(function (state) {
      return new Date().getTime() - state.loadedAt.get(peersKey, 0) > 1000 * 60 * 60 * 24;
    });
    var _ref7 = (0, _react.useState)(false),
      _ref8 = _slicedToArray(_ref7, 2),
      loadPeerRank = _ref8[0],
      setLoadPeerRank = _ref8[1];
    (0, _react.useEffect)(function () {
      if (loadingQuestions || subjectsLoading) return;
      if (loadedQuestions && loadedQuestionsThisSession) return;
      dispatch(_this.Performance.performanceQuestionsFetch(questionBankId, userId));
    }, [subjectsLoading, loadedQuestions, loadedQuestionsThisSession]);
    (0, _react.useEffect)(function () {
      if (loadingPeers || subjectsLoading) return;
      if (loadedPeers && !stalePeers) return;
      dispatch(_this.Performance.performancePeersFetch(questionBankId, userId));
    }, [subjectsLoading, loadedPeers, stalePeers]);
    (0, _react.useEffect)(function () {
      if (loadPeerRank && loadedPeers) dispatch(_this.Performance.performancePeersFetch(questionBankId, userId));
      setLoadPeerRank(subjectsLoading);
    }, [subjectsLoading]);
    return loadingQuizzesOrResponses || subjectsLoading || loadingQuestions || !loadedQuestions || loadingPeers || !loadedPeers;
  };
});
var _default = exports.default = PerformanceHooks;